import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useGlobalStore } from '../../../store'
import { ROUTE_PROJECTS } from '../../../constants'
import { getImageUrl } from '../../../util'
import {
  TopbarContainer,
  LogoText,
  PageTitle,
  StudyTitle,
  StudySubTitle,
  PageSubTitle,
  Actions,
} from './style'
import { IconHamburderMenu, IconClose } from '../../../assets/images/iconsV2'
import { MuiButton } from '../../../components'

const Topbar = ({ pageTitle, pageSubTitle, studyTitle, studySubTitle, actions, setShowLhsMenu, showHamburgerMenu, setHeaderHamburgerActive, headerHamburgerActive }) => {
  const { company } = useGlobalStore()
  const logoPath = getImageUrl('logos/default', company?.CompanyLogo, 'svg')

  const handleClick = (flag) => {
    setShowLhsMenu(flag);
    setHeaderHamburgerActive(flag);
  }

  return (
    <TopbarContainer className='desktopMenu'>
      {showHamburgerMenu && (
        headerHamburgerActive ? (
          <MuiButton
            variant='text'
            color='light'
            size='small'
            startIcon={<IconClose />}
            onClick={() => handleClick(false)}
          />
        ) : (
          <MuiButton
            startIcon={<IconHamburderMenu />}
            color='light'
            size='small'
            variant='text'
            onClick={() => handleClick(true)}
            className='hamburderMenu'
          />
        )
      )}
      {company && logoPath && (
        <>
          {pageTitle === 'Projects' ? (
            <LogoText src={logoPath} alt='' />
          ) : (
            <Link to={ROUTE_PROJECTS} style={{ display: 'flex' }}>
              <LogoText src={logoPath} alt='' />
            </Link>
          )}
        </>
      )}
      {pageTitle && (
        <PageTitle>
          {pageTitle}
          {pageSubTitle && <PageSubTitle>{pageSubTitle}</PageSubTitle>}
        </PageTitle>
      )}
      {studyTitle && (
        <StudyTitle>
          {studyTitle}
          {studySubTitle && <StudySubTitle>{studySubTitle}</StudySubTitle>}
        </StudyTitle>
      )}
      {actions && <Actions>{actions}</Actions>}
    </TopbarContainer>
  )
}

export default Topbar

Topbar.propTypes = {
  pageTitle: PropTypes.string,
  pageSubTitle: PropTypes.string,
  studyTitle: PropTypes.string,
  studySubTitle: PropTypes.string,
  actions: PropTypes.array,
}
